import { render, staticRenderFns } from "./SelectInputConfig.vue?vue&type=template&id=6e879ae6&scoped=true"
import script from "./SelectInputConfig.vue?vue&type=script&lang=js"
export * from "./SelectInputConfig.vue?vue&type=script&lang=js"
import style0 from "./SelectInputConfig.vue?vue&type=style&index=0&id=6e879ae6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e879ae6",
  null
  
)

export default component.exports